import { ComponentWithAs, createIcon, IconProps } from "@chakra-ui/react";

export const getAccountIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.5 0.25C4.21875 0.25 0.75 3.71875 0.75 8C0.75 12.2812 4.21875 15.75 8.5 15.75C12.7812 15.75 16.25 12.2812 16.25 8C16.25 3.71875 12.7812 0.25 8.5 0.25ZM8.5 3.25C10 3.25 11.25 4.5 11.25 6C11.25 7.53125 10 8.75 8.5 8.75C6.96875 8.75 5.75 7.53125 5.75 6C5.75 4.5 6.96875 3.25 8.5 3.25ZM8.5 14C6.65625 14 5 13.1875 3.90625 11.875C4.5 10.7812 5.65625 10 7 10C7.0625 10 7.125 10.0312 7.21875 10.0625C7.625 10.1875 8.03125 10.25 8.5 10.25C8.9375 10.25 9.375 10.1875 9.75 10.0625C9.84375 10.0312 9.90625 10 10 10C11.3125 10 12.4688 10.7812 13.0625 11.875C11.9688 13.1875 10.3125 14 8.5 14Z"
          fill={color}
        />
      </svg>
    ),
  });
};

export const getUploadIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.25152 17C7.25152 17.4142 7.58731 17.75 8.00152 17.75C8.41573 17.75 8.75152 17.4142 8.75152 17H7.25152ZM8.00152 6.33333L8.53185 5.803C8.23896 5.51011 7.76408 5.51011 7.47119 5.803L8.00152 6.33333ZM10.6712 10.0637C10.9641 10.3566 11.439 10.3566 11.7319 10.0637C12.0247 9.77077 12.0247 9.2959 11.7319 9.003L10.6712 10.0637ZM4.27119 9.003C3.9783 9.2959 3.9783 9.77077 4.27119 10.0637C4.56408 10.3566 5.03896 10.3566 5.33185 10.0637L4.27119 9.003ZM5.33485 15.0826C5.74907 15.0826 6.08485 14.7468 6.08485 14.3326C6.08485 13.9184 5.74907 13.5826 5.33485 13.5826V15.0826ZM3.73343 14.3326V15.0826V14.3326ZM1.6001 12.1993H0.850098H1.6001ZM1.6001 3.13333H0.850098H1.6001ZM3.73343 1V0.25V1ZM12.2668 1V0.25V1ZM14.4001 3.13333H15.1501H14.4001ZM14.4001 12.1993H15.1501H14.4001ZM12.2668 14.3326V15.0826V14.3326ZM10.6668 13.5826C10.2526 13.5826 9.91676 13.9184 9.91676 14.3326C9.91676 14.7468 10.2526 15.0826 10.6668 15.0826V13.5826ZM8.75152 17V6.33333H7.25152V17H8.75152ZM11.7319 9.003L8.53185 5.803L7.47119 6.86366L10.6712 10.0637L11.7319 9.003ZM7.47119 5.803L4.27119 9.003L5.33185 10.0637L8.53185 6.86366L7.47119 5.803ZM5.33485 13.5826H3.73343V15.0826H5.33485V13.5826ZM3.73343 13.5826C3.36655 13.5826 3.01469 13.4369 2.75527 13.1775L1.69461 14.2381C2.23534 14.7788 2.96872 15.0826 3.73343 15.0826V13.5826ZM2.75527 13.1775C2.49584 12.918 2.3501 12.5662 2.3501 12.1993H0.850098C0.850098 12.964 1.15388 13.6974 1.69461 14.2381L2.75527 13.1775ZM2.3501 12.1993V3.13333H0.850098V12.1993H2.3501ZM2.3501 3.13333C2.3501 2.76645 2.49584 2.41459 2.75527 2.15517L1.69461 1.09451C1.15388 1.63524 0.850098 2.36863 0.850098 3.13333H2.3501ZM2.75527 2.15517C3.01469 1.89574 3.36655 1.75 3.73343 1.75V0.25C2.96872 0.25 2.23534 0.553779 1.69461 1.09451L2.75527 2.15517ZM3.73343 1.75H12.2668V0.25H3.73343V1.75ZM12.2668 1.75C12.6336 1.75 12.9855 1.89574 13.2449 2.15517L14.3056 1.09451C13.7649 0.553779 13.0315 0.25 12.2668 0.25V1.75ZM13.2449 2.15517C13.5044 2.41459 13.6501 2.76645 13.6501 3.13333H15.1501C15.1501 2.36863 14.8463 1.63524 14.3056 1.09451L13.2449 2.15517ZM13.6501 3.13333V12.1993H15.1501V3.13333H13.6501ZM13.6501 12.1993C13.6501 12.5662 13.5044 12.918 13.2449 13.1775L14.3056 14.2381C14.8463 13.6974 15.1501 12.964 15.1501 12.1993H13.6501ZM13.2449 13.1775C12.9855 13.4369 12.6336 13.5826 12.2668 13.5826V15.0826C13.0315 15.0826 13.7649 14.7788 14.3056 14.2381L13.2449 13.1775ZM12.2668 13.5826H10.6668V15.0826H12.2668V13.5826Z"
          fill={color}
        />
      </svg>
    ),
  });
};

export const getStarIcon = (
  color: string,
  outlineColor: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6773 3.24014L12.5897 7.11507H16.7466C16.8905 7.11506 17.0313 7.15621 17.1524 7.23367C17.2736 7.31112 17.3701 7.42165 17.4304 7.55218C17.4908 7.68272 17.5125 7.8278 17.4931 7.97029C17.4736 8.11278 17.4138 8.24672 17.3206 8.35628L14.1876 12.0372L15.3148 16.2248C15.3517 16.3633 15.3484 16.5095 15.3051 16.6462C15.2619 16.7828 15.1805 16.9043 15.0706 16.9964C14.9607 17.0884 14.8269 17.1472 14.6847 17.1658C14.5426 17.1844 14.3981 17.162 14.2682 17.1014L10.002 15.0796L5.87575 17.0987C5.74739 17.1623 5.60356 17.1879 5.46115 17.1726C5.31873 17.1573 5.18362 17.1017 5.07167 17.0124C4.95972 16.923 4.87557 16.8036 4.82908 16.6681C4.78259 16.5327 4.77569 16.3867 4.80919 16.2475L5.81243 12.0372L2.67941 8.35628C2.58625 8.24672 2.5264 8.11278 2.50693 7.97029C2.48747 7.8278 2.5092 7.68272 2.56956 7.55218C2.62992 7.42165 2.72638 7.31112 2.84755 7.23367C2.96873 7.15621 3.10954 7.11506 3.25335 7.11507H7.41426L9.32674 3.24014C9.3888 3.114 9.48496 3.00777 9.60431 2.93348C9.72365 2.8592 9.86142 2.81982 10.002 2.81982C10.1426 2.81982 10.2803 2.8592 10.3997 2.93348C10.519 3.00777 10.6152 3.114 10.6773 3.24014V3.24014Z"
          stroke={outlineColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  });
};

export const attachmentIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 6.97119L8.68201 14.2898C7.8381 15.1338 6.6935 15.6079 5.50002 15.6079C4.30654 15.6079 3.16194 15.1338 2.31803 14.2898C1.47411 13.4459 1 12.3013 1 11.1078C1 9.91437 1.47411 8.76977 2.31803 7.92585L8.32868 1.91586C8.60542 1.62933 8.93645 1.40079 9.30246 1.24356C9.66848 1.08633 10.0621 1.00357 10.4605 1.00011C10.8588 0.996652 11.2538 1.07256 11.6225 1.2234C11.9912 1.37424 12.3262 1.597 12.6079 1.87868C12.8895 2.16036 13.1123 2.49531 13.2631 2.864C13.414 3.23269 13.4899 3.62773 13.4864 4.02606C13.483 4.4244 13.4002 4.81806 13.243 5.18407C13.0857 5.55008 12.8572 5.88112 12.5707 6.15786L6.56068 12.1712C6.27782 12.4445 5.89895 12.5957 5.50565 12.5924C5.11235 12.589 4.73611 12.4313 4.45796 12.1532C4.1798 11.8752 4.02199 11.499 4.01851 11.1057C4.01503 10.7124 4.16616 10.3335 4.43935 10.0505L10.45 4.03786"
          stroke="#232323"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  });
};

export const unionIcon = (color: string): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="40"
        height="40"
        transform-origin="center"
        viewBox="0 0 20 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.94099 10H0.0153303L3.77898 5.00946L0.000244141 0H2.92608L6.70534 5.00946L2.94099 10ZM7.5105 10H4.58485L8.34866 5.00946L4.56976 0H7.49559L11.2748 5.00946L7.5105 10Z"
          fill="#A7A7A7"
        />
      </svg>
    ),
  });
};

export const locationIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.51758 8.23607C7.51758 8.95692 7.80394 9.64826 8.31366 10.158C8.82339 10.6677 9.51472 10.9541 10.2356 10.9541C10.9564 10.9541 11.6478 10.6677 12.1575 10.158C12.6672 9.64826 12.9536 8.95692 12.9536 8.23607C12.9536 7.51521 12.6672 6.82387 12.1575 6.31415C11.6478 5.80443 10.9564 5.51807 10.2356 5.51807C9.51472 5.51807 8.82339 5.80443 8.31366 6.31415C7.80394 6.82387 7.51758 7.51521 7.51758 8.23607V8.23607Z"
          stroke="#A7A7A7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4652 8.23259C17.4652 14.5812 11.8945 18.142 10.5307 18.9207C10.4398 18.9727 10.3369 19 10.2322 19C10.1275 19 10.0246 18.9727 9.93364 18.9207C8.5699 18.1412 3 14.5796 3 8.23259C3 6.31439 3.762 4.47475 5.11838 3.11838C6.47475 1.762 8.31439 1 10.2326 1C12.1508 1 13.9904 1.762 15.3468 3.11838C16.7032 4.47475 17.4652 6.31439 17.4652 8.23259Z"
          stroke="#A7A7A7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  });
};
